import * as SwitchPrimitive from "@radix-ui/react-switch"
import type { ComponentProps } from "react"
import { cn } from "@/lib/utils.js"

/**
 * On or off, where the state has to be readable without opening anything.
 *
 * A rule's enablement was a "Wyłącz" ghost button — a control that names the
 * *action* rather than the state, so a list of them answers "what is running?"
 * only by reading every label backwards. A switch answers it at a glance, which
 * is the whole job of the rule list.
 *
 * Radix rather than a styled checkbox: it carries `role="switch"` and its
 * checked state to assistive technology, which a `<button>` with a class does
 * not. The dependency was already in `package.json` and wired to nothing.
 */
export function Switch({ className, ...props }: ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        "inline-flex h-[18px] w-8 shrink-0 cursor-pointer items-center rounded-full transition-colors",
        "bg-input data-[state=checked]:bg-primary",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          "pointer-events-none block size-3.5 rounded-full bg-card shadow-xs transition-transform",
          "translate-x-0.5 data-[state=checked]:translate-x-[15px]",
        )}
      />
    </SwitchPrimitive.Root>
  )
}
